(function donationblockScript($, Drupal) {
  Drupal.behaviors.donationblock = {
    attach() {
      // Improves layout by putting Other textfield inside radios wrapper.
      $(
        '.donation-form .js-form-item-amount-other .js-form-type-textfield'
      ).each(function groupOther() {
        $(this).appendTo($(this).siblings('.form-radios'));
      });

      // Adds placeholder text to Other Amount input for clarity.
      $(
        '.donation-form .js-form-item-amount-other .js-form-type-textfield input'
      ).attr('placeholder', 'Enter Amount');

      // Simulates Drupal hide/show behaviour for PatternLab.
      $('.pl .form-radios input').on('click', function showOther() {
        if ($('input[value="select_or_other"]').is(':checked')) {
          $(this)
            .parent()
            .next('.js-form-type-textfield')
            .show();
        } else {
          $(this)
            .parent()
            .siblings('.js-form-type-textfield')
            .hide();
        }
      });
      $('.pl .block.donation-form #edit-frequency input').on(
        'click',
        function showMonthly() {
          if ($(this).is('#edit-frequency-monthly:checked')) {
            $('.pl .block.donation-form #edit-amount-onetime').hide();
            $('.pl .block.donation-form #edit-amount-monthly').show();
          } else {
            $('.pl .block.donation-form #edit-amount-onetime').show();
            $('.pl .block.donation-form #edit-amount-monthly').hide();
          }
        }
      );

      const $inMemoryCheckbox = $(
        '.pl .block.donation-form .js-form-item-in-memory input'
      );
      const $memoryName = $(
        '.pl .block.donation-form .js-form-item-in-memory-name'
      );
      const $memoryMemorial = $(
        '.pl .block.donation-form .js-form-item-in-memory-memorial'
      );
      $inMemoryCheckbox.on('click', function showMemory() {
        if ($(this).is(':checked')) {
          $memoryName.show();
          $memoryMemorial.show();
        } else {
          $memoryName.hide();
          $memoryMemorial.hide();
        }
      });
    }
  };
}(jQuery, Drupal));
